import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FadeInHOC from "../FadeInHOC";
import Vimeo from "@u-wave/react-vimeo";
import ReactCursorPosition from "react-cursor-position";
import IframeCursor from "../../IframeCursor";

const styles = (theme) => ({
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  root: {
    position: "relative",
    zIndex: 2,
    opacity: 0,
    transition: "all 3s cubic-bezier(.4,.28,0,1.03)",
    paddingBottom: "56.25%",
    height: "0",
    boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.2)",
    width: "100%",
    overflow: "hidden",
    marginTop: (props) => `${props.noMargin ? 0 : "2rem"}`,
  },
});

const useStyles = makeStyles(styles);

export default function VideoFrame({ id, noMarginTop }) {
  const [paused, setPaused] = useState(true);
  const pauseVideo = () => setPaused(true);
  const startVideo = () => setPaused(false);
  const props = { noMargin: noMarginTop };
  const classes = useStyles(props);
  const showTitle = false;
  return (
    <FadeInHOC width="100%" rootClass={classes.root} seconds={3} div>
      {/* <ReactCursorPosition className="fullParent">
        <IframeCursor
          paused={paused}
          startVideo={startVideo}
          pauseVideo={pauseVideo}
        />
      </ReactCursorPosition> */}
      <Vimeo
        className={classes.iframe}
        video={id}
        responsive
        paused={paused}
        color="09349C"
        showTitle={showTitle}
        showByline={showTitle}
        showPortrait={showTitle}
      />
    </FadeInHOC>
  );
}
